/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Forge Partner Development
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////

function launchViewer(urn, viewableId) {

  // Init public link button
  $('.settings__button--public-link').attr('href', '//' + window.location.host + '?urn=' + urn + '&public');

  // Options
  var options = {
    env: 'AutodeskProduction',
    language: settings.language || 'en',
    getAccessToken: getForgeToken,
    // Handle BIM 360 US and EU regions
    api:
      'derivativeV2' +
      (atob(urn.replace('_', '/')).indexOf('emea') > -1 ? '_EU' : '')
  };

  // Init Autodesk viewer
  Autodesk.Viewing.Initializer(options, () => {
    var viewerElement = document.getElementById('forgeViewer');

    viewer = new Autodesk.Viewing.GuiViewer3D(viewerElement, {
      extensions: [
        'Autodesk.VisualClusters',
        'Autodesk.DocumentBrowser'
      ]
    });

    const onExtensionLoaded = (e) => {
      if (e.extensionId === 'Autodesk.Measure') {
        // Set mesurement units
        // Pick from available values:
        // 'decimal-ft'
        // 'ft-and-fractional-in'
        // 'ft-and-decimal-in'
        // 'decimal-in'
        // 'fractional-in'
        // 'm'
        // 'cm'
        // 'mm'
        // 'm-and-cm'
        var measureExtension = viewer.getExtension('Autodesk.Measure');
        measureExtension.setUnits('cm');
        measureExtension.setPrecision(2);

        // No need to listen to this event anymore
        viewer.removeEventListener(
          Autodesk.Viewing.EXTENSION_LOADED_EVENT,
          onExtensionLoaded
        );
      }
    };

    viewer.addEventListener(
      Autodesk.Viewing.EXTENSION_LOADED_EVENT,
      onExtensionLoaded
    );

    viewer.start();

    console.log(
      '\x1b[36mNode ID (urn):\x1b[37m ' + urn
    );

    var ids = getProjectIds();

    $('.project-details__value--node-id').html(urn);
    $('.project-details__value--project-id').html(ids.projectId);
    $('.project-details__value--project-id-api').html(settings.protocolProjectId);

    var documentId = 'urn:' + urn;
    Autodesk.Viewing.Document.load(
      documentId,
      onDocumentLoadSuccess,
      onDocumentLoadFailure
    );

    // Smooth navigation
    viewer.autocam.shotParams.destinationPercent = 3;
    viewer.autocam.shotParams.duration = 3;
  });

  function onDocumentLoadSuccess(doc) {
    // If a viewableId was specified, load that view, otherwise the default view
    var viewables = viewableId
      ? doc.getRoot().findByGuid(viewableId)
      : doc.getRoot().getDefaultGeometry();

    viewer.loadDocumentNode(doc, viewables).then((i) => {
      new Dashboard(viewer);
    });
  }

  function onDocumentLoadFailure(viewerErrorCode) {
    error();
    console.error('Document Load Failure - errorCode: ' + viewerErrorCode);
  }
}
